module.exports = __webpack_public_path__ + "img/7.34351bd0.jpg";